// // src/pages/ProductComparison.js
// import React, { useState, useEffect, useContext } from 'react';
// import {
//   Container,
//   Typography,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   FormControl,
//   FormLabel,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import ProgressContext from '../context/ProgressContext';
// import { UserContext } from '../context/UserContext';
// import { useNavigate } from 'react-router-dom';
// import HorizontalStepper from '../components/HorizontalStepper';
// import axios from 'axios';
// import BackButton from '../components/BackButton';
// import { DataGrid } from '@mui/x-data-grid';
// import DOMPurify from 'dompurify';

// import apiClient from '../utils/apiClient';

// function ProductComparison() {
//   const { steps, currentStep, nextStep, setCurrentStep } = useContext(ProgressContext);
//   const {
//     agentStrategy,
//     setAgentStrategy,
//     pitchResponse,
//     ebiExplanations,
//     ebiOutputs,
//     selectedProducts,
//     selectedProductCodes,
//     comparisonOutput,
//     setComparisonOutput,
//     productDetails,
//     setProductDetails,
//     combinedEbiData,
//     setCombinedEbiData,
//   } = useContext(UserContext);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   // Check if we are in manual strategy mode
//   const isManualStrategy = agentStrategy?.strategy === "2";
//   // Local state to hold user selection if manual strategy
//   const [manualSelection, setManualSelection] = useState(
//     agentStrategy?.recommendation_type === "1.1" || agentStrategy?.recommendationType === "1.1"
//       ? "comparison"
//       : agentStrategy?.recommendation_type === "1.2" || agentStrategy?.recommendationType === "1.2"
//         ? "product_mix"
//         : ""
//   );
//   // Decide the heading based on recommendation_type or recommendationType
//   let headingText = "Product Comparison"
//   if (
//     agentStrategy?.recommendation_type === "1.2" || 
//     agentStrategy?.recommendationType === "1.2"
//   ) {
//     headingText = "Product Mix Benefit Explanation"
//   }
//   // Set the current step on component mount
//   useEffect(() => {
//     const stepIndex = steps.findIndex((step) => step.path === '/dashboard/product-comparison');
//     if (stepIndex !== -1) {
//       setCurrentStep(stepIndex);
//     }
//   }, [steps, setCurrentStep]);
//   // Prepare productDetails if not already set
//   useEffect(() => {
//     if (!productDetails || Object.keys(productDetails).length === 0) {
//       const details = {};
//       if (selectedProductCodes && selectedProducts) {
//         selectedProductCodes.forEach((code, idx) => {
//           details[code] = selectedProducts[idx];
//         });
//       }
//       setProductDetails(details);
//     }
//   }, [productDetails, selectedProducts, selectedProductCodes, setProductDetails]);
//   // Get product codes with EBI data
//   const ebiProductCodes = ebiOutputs ? Object.keys(ebiOutputs) : [];
//   // Generate comparison data
//   const generateComparison = async () => {
//     if (ebiProductCodes.length < 2) {
//       setComparisonOutput("Comparison or product mix benefits cannot be shown if more than 2 products EBI is not generated. Please select multiple products for the same from Agent Strategy or Product Recommedation section.");
//       return;
//     }
//     setLoading(true);
//     const requestData = {
//       agent_strategy: agentStrategy,
//       pitch_response: pitchResponse,
//       ebi_explanations: ebiExplanations,
//       ebi_outputs: ebiOutputs,
//       product_details: productDetails,
//     };
//     try {
//       // const response = await axios.post(
//       //   'http://localhost:8000/liva/api/product-comparison',
//       const response = await apiClient.post(
//         'product-comparison',
//         requestData,
//         { withCredentials: true }
//       );
//       const data = response.data;
//       setComparisonOutput(data.comparison_output);
//       setCombinedEbiData(data.combined_ebi_data);
//       setLoading(false);
//     } catch (error) {
//       console.error('Error generating comparison:', error);
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (ebiProductCodes.length >= 1 && !comparisonOutput) {
//       if (isManualStrategy) {
//         if (manualSelection) {
//           generateComparison();
//         }
//       } else {
//         generateComparison();
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [ebiProductCodes, manualSelection]);
//   const handleRegenerate = () => {
//     generateComparison();
//   };
//   const handleNext = () => {
//     nextStep();
//     navigate('/dashboard/summary-creation');
//   };
//   const nextStepLabel = steps[currentStep + 1]?.label
//     ? `Next to ${steps[currentStep + 1].label}`
//     : 'Finish';
//   const prepareDataGridData = () => {
//     if (!combinedEbiData || Object.keys(combinedEbiData).length === 0) {
//       return { columns: [], rows: [] };
//     }
//     const variables = Object.keys(combinedEbiData);
//     const products = Object.keys(combinedEbiData[variables[0]] || {});
//     const columns = [
//       { field: 'id', headerName: 'Variable', flex: 1 },
//       ...products.map((product) => ({
//         field: product,
//         headerName: product,
//         flex: 1,
//       })),
//     ];
//     const rows = variables.map((variable) => {
//       const row = { id: variable };
//       products.forEach((product) => {
//         const value = combinedEbiData[variable]?.[product];
//         row[product] = value !== undefined && value !== null ? value : 'N/A';
//       });
//       return row;
//     });
//     return { columns, rows };
//   };
//   const { columns, rows } = prepareDataGridData();
//   return (
//     <Container maxWidth="md" sx={{ mt: 4 }}>
//       <HorizontalStepper />
//       <BackButton />
//       <motion.div
//         initial={{ opacity: 0, x: -50 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
//           {headingText}
//         </Typography>
//         {ebiProductCodes.length < 2 ? (
//           <Card
//             sx={{
//               mt: 2,
//               backgroundColor: 'rgba(255, 255, 255, 0.7)',
//               backdropFilter: 'blur(10px)',
//               boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
//               borderRadius: 2,
//             }}
//           >
//             <CardContent>
//               <Typography variant="body1">
//                 Comparison or product mix benefits cannot be shown for a single product. Please select multiple products.
//               </Typography>
//             </CardContent>
//           </Card>
//         ) : (
//           <>
//             {loading ? (
//               <CircularProgress sx={{ mt: 4 }} />
//             ) : (
//               <>
//                 {comparisonOutput && (
//                   <Card
//                     sx={{
//                       mt: 2,
//                       backgroundColor: 'rgba(255, 255, 255, 0.7)',
//                       backdropFilter: 'blur(10px)',
//                       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
//                       borderRadius: 2,
//                     }}
//                   >
//                     <CardContent>
//                       <Typography variant="h6">
//                         {agentStrategy?.recommendation_type === "1.2" || agentStrategy?.recommendationType === "1.2"
//                           ? "Cumulative Cash Flow Benefit"
//                           : "Benefits and Cash Flow Comparision"}
//                       </Typography>
//                       <Typography
//                           component="div"
//                           dangerouslySetInnerHTML={{
//                             __html: DOMPurify.sanitize(
//                               comparisonOutput
//                             ),
//                           }}
//                         />
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         sx={{ mt: 4 }}
//                         onClick={handleRegenerate}
//                         disabled={loading}
//                       >
//                         {loading ? <CircularProgress size={24} /> : 'Regenerate'}
//                       </Button>
//                     </CardContent>
//                   </Card>
//                 )}
//                 {combinedEbiData && Object.keys(combinedEbiData).length > 0 && (
//                   <Card
//                     sx={{
//                       mt: 4,
//                       backgroundColor: 'rgba(255, 255, 255, 0.7)',
//                       backdropFilter: 'blur(10px)',
//                       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
//                       borderRadius: 2,
//                     }}
//                   >
//                     <CardContent>
//                       <Typography variant="h6" sx={{ mb: 2 }}>
//                         Combined EBI Data
//                       </Typography>
//                       <div style={{ height: 400, width: '100%' }}>
//                         <DataGrid
//                           columns={columns}
//                           rows={rows}
//                           pageSize={5}
//                           rowsPerPageOptions={[5]}
//                           disableSelectionOnClick
//                         />
//                       </div>
//                     </CardContent>
//                   </Card>
//                 )}
//                 {comparisonOutput && (
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     sx={{ mt: 4, mb: 4 }}
//                     onClick={handleNext}
//                   >
//                     {nextStepLabel}
//                   </Button>
//                 )}
//               </>
//             )}
//           </>
//         )}
//       </motion.div>
//     </Container>
//   );
// }
// export default ProductComparison;


// src/pages/ProductComparison.js
import React, { useState, useEffect, useContext } from 'react';
import {
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Box,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { motion } from 'framer-motion';
import ProgressContext from '../context/ProgressContext';
import { UserContext } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import HorizontalStepper from '../components/HorizontalStepper';
import axios from 'axios';
import BackButton from '../components/BackButton';
import { DataGrid } from '@mui/x-data-grid';
import DOMPurify from 'dompurify';
import { Modal, IconButton, TextField } from '@mui/material';
import ThumbDownAltOutlined from '@mui/icons-material/ThumbDownAltOutlined'
import ThumbUpAltOutlined from '@mui/icons-material/ThumbUpAltOutlined'
import { ThumbDownAlt, ThumbUpAlt } from '@mui/icons-material';

import apiClient from '../utils/apiClient';
import apiClient4 from '../utils/apiClient4';


function ProductComparison() {
  const { steps, currentStep, nextStep, setCurrentStep } = useContext(ProgressContext);
  const {
    agentStrategy,
    setAgentStrategy,
    pitchResponse,
    ebiExplanations,
    ebiOutputs,
    selectedProducts,
    selectedProductCodes,
    comparisonOutput,
    setComparisonOutput,
    productDetails,
    setProductDetails,
    combinedEbiData,
    setCombinedEbiData,
    productComparison
  } = useContext(UserContext);
  const [modalOpen, setModalOpen] = useState(true)
  const handleOpen = () => setModalOpen(true)
  const handleClose = () => setModalOpen(false)
  const [feedback_open, setFeedback_open] = useState(0)
  const [feedback_liked, setFeedback_licked] = useState(false)
  const [feedback_disliked, setFeedback_dislicked] = useState(false)
  const [feedback_value, feedback_value_set] = useState('')

  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // ────────────────────────────────────────────────────────────────
  // NEW : viewMode state controlled by a flip-button
  // ────────────────────────────────────────────────────────────────
  const [viewMode, setViewMode] = useState(
    agentStrategy?.recommendation_type === '1.2' ||
      agentStrategy?.recommendationType === '1.2'
      ? 'cumulative'
      : 'comparison',
  );
  // Update current step on mount
  useEffect(() => {
    const stepIndex = steps.findIndex((step) => step.path === '/dashboard/product-comparison');
    if (stepIndex !== -1) setCurrentStep(stepIndex);
  }, [steps, setCurrentStep]);
  // Prepare productDetails if not already set
  useEffect(() => {
    if (!productDetails || Object.keys(productDetails).length === 0) {
      const details = {};
      if (selectedProductCodes && selectedProducts) {
        selectedProductCodes.forEach((code, idx) => {
          details[code] = selectedProducts[idx];
        });
      }
      setProductDetails(details);
    }
  }, [productDetails, selectedProducts, selectedProductCodes, setProductDetails]);
useEffect(() => {
   const handlePopState = () => window.history.pushState(null, "", window.location.href);
   window.history.pushState(null, "", window.location.href);
   window.addEventListener("popstate", handlePopState);
   return () => window.removeEventListener("popstate", handlePopState);
}, []);
  const dislikeFeedback = async () =>{
    if (!feedback_liked && !feedback_disliked) {
      setFeedback_open(1)
    }
  }
  const likeFeedback = async () => {
    if (!feedback_liked && !feedback_disliked) {
      const response = await apiClient.post('/feedback', {
        "session_id": userNTID,
        "query": "EBI Generation",
        "response": "",
        "feedback": "thumbs_up",
        "product": "",
        "ntID": userNTID

      }, { withCredentials: true });

      setFeedback_licked(true)
    }

  }
  const submitFeedback = async () => {
    if (!feedback_disliked) {
      const response = await apiClient.post('/feedback', {
        "session_id": userNTID,
        "query": "EBI Generation",
        "response": feedback_value,
        "feedback": "thumbs_down",
        "product": "",
        "ntID": userNTID
      }, { withCredentials: true });
      FeedbackPopupClose()
      setFeedback_dislicked(true)
    }

  }
    const FeedbackPopupClose = () => {
    setFeedback_open(0)
  }


  // Product codes that have EBI data
  const ebiProductCodes = ebiOutputs ? Object.keys(ebiOutputs) : [];
  // ────────────────────────────────────────────────────────────────
  // Core API call
  // ────────────────────────────────────────────────────────────────
  const getEqouteDetails = async (xml_details) =>{
    let headers = {
        "Content-Type": "text/xml; charset=utf-8",
        "SOAPAction": "http://tempuri.org/GenerateEBIDigital",
    }
    xml_details = xml_details.replaceAll('xmlns:xsd="http://www.w3.org/2001/XMLSchema"', "")
    // let response = await apiClient4.post('https://api-dex.iciciprulife.com/v1/core/quote', xml_details, headers)
    // const parser = new DOMParser();
    // const xmlDoc = parser.parseFromString(response.data, "text/xml")
    //     console.log("xmlDoc",xmlDoc)
    // const resultTag = xmlDoc.getElementsByTagName("GenerateEBIDigitalPDFResult")[0];
    // const pdfUrl = resultTag.textContent.trim();
    // window.open(pdfUrl, '_blank')
  }

  const getEqouteEbiOutput = async (product_name, product_code, ebi_output) =>{
    let response = apiClient.post('/explain_output', {
        "sessionID": 'DILI1234',
        "product_name": product_name,
        "product_code": product_code,
        "ebi_output":  ebi_output,
      })
      console.log("ebioutput resp",response)
  }

  
  const generateComparison = async () => {
    if (selectedProductCodes.length < 2) {
      setComparisonOutput(
        'Comparison or product mix benefits cannot be shown if EBI is generated for fewer than 2 products.',
      );
      return;
    }
    setLoading(true);
    // Inject the chosen viewMode into a *copy* of agentStrategy
    const updatedAgentStrategy = {
      ...agentStrategy,
      recommendation_type: viewMode === 'cumulative' ? '1.2' : '1.1',
      recommendationType: viewMode === 'cumulative' ? '1.2' : '1.1',
    };
    const requestData = {
      agent_strategy: updatedAgentStrategy,
      pitch_response: pitchResponse,
      ebi_explanations: ebiExplanations,
      ebi_outputs: ebiOutputs,
      product_details: productDetails,
      ntID: userNTID
    };

    console.log("request data",requestData)
    productComparison.forEach((i)=>{
      let resp = getEqouteDetails(i.xml_details)
      getEqouteEbiOutput('abc', i)
    })
         
    console.log("productComparison", productComparison)
    try {
      // const { data } = await axios.post(
      //   'http://localhost:8000/api/product-comparison',
      //   requestData,
      //   { withCredentials: true },
      // );
      const { data } = await apiClient.post(
        'product-comparison',
        requestData,
        { withCredentials: true }
      );
      setComparisonOutput(data.comparison_output);
      setCombinedEbiData(data.combined_ebi_data);
    } catch (err) {
      console.error('Error generating comparison:', err);
    } finally {
      setLoading(false);
    }
  };
  // (Re)generate when products load or mode flips
  useEffect(() => {
    console.log("ebiProductCodes", selectedProductCodes)
    if (selectedProductCodes.length >= 1) generateComparison();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProductCodes, viewMode]);
  // Flip-button handler
  const handleModeChange = (_e, newMode) => {
    if (!newMode) return; // ignore un-select
    setViewMode(newMode);
    setComparisonOutput(null); // clear old output while new one loads
    // keep context copy in sync for downstream pages (no backend change)
    setAgentStrategy((prev) => ({
      ...prev,
      recommendation_type: newMode === 'cumulative' ? '1.2' : '1.1',
      recommendationType: newMode === 'cumulative' ? '1.2' : '1.1',
    }));
  };
  const handleNext = () => {
    nextStep();
    navigate('/dashboard/summary-creation');
  };
  const nextStepLabel = steps[currentStep + 1]?.label
    ? `Next to ${steps[currentStep + 1].label}`
    : 'Finish';
  const prepareDataGridData = () => {
    if (!combinedEbiData || Object.keys(combinedEbiData).length === 0) {
      return { columns: [], rows: [] };
    }
    const variables = Object.keys(combinedEbiData);
    const products = Object.keys(combinedEbiData[variables[0]] || {});
    const columns = [
      { field: 'id', headerName: 'Variable', flex: 1 },
      ...products.map((product) => ({
        field: product,
        headerName: product,
        flex: 1,
      })),
    ];
    const rows = variables.map((variable) => {
      const row = { id: variable };
      products.forEach((product) => {
        const value = combinedEbiData[variable]?.[product];
        row[product] = value ?? 'N/A';
      });
      return row;
    });
    return { columns, rows };
  };
  const { columns, rows } = prepareDataGridData();
  // Dynamic headings based on flip-choice
  const headingText =
    viewMode === 'cumulative'
      ?  'Product Mix Benefit Explanation'
      : 'Product Comparison';
  const cardSubHeading =
    viewMode === 'cumulative'
      ? 'Cumulative Cash Flow Benefit'
      : 'Benefits and Cash-Flow Comparison';
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <HorizontalStepper />
      <BackButton />
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
                              <Button variant='contained' style={{float:'right'}} onClick={handleOpen}>Open Customer Pitch</Button>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          {headingText}
        </Typography>
        {JSON.stringify(productComparison)}
        {/* Flip-button selector */}
        <Box sx={{ mt: 2, mb: 3 }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleModeChange}
            aria-label="comparison mode"
          >
            <ToggleButton value="comparison" aria-label="comparison">
              Comparison

              {JSON.stringify(selectedProductCodes)}
            </ToggleButton>
            
            <ToggleButton
              value="cumulative"
              aria-label="cumulative"
              disabled={selectedProductCodes.length < 2}
            >
              Cumulative Benefit
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>


      <Modal open={modalOpen} onClose={handleClose}>
        <div style={{ margin: '100px' }}>
          <div style={{ padding: '20px', backgroundColor: 'white', overflowY: 'scroll', height: '600px' }}>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              <h2>Pitch we are giving:
                <Button variant="contained" color="primary" sx={{ float: 'right' }} onClick={handleClose}>Close</Button></h2>

            </Typography>
            <Typography
              sx={{ marginBottom: '60px' }}
              component="div"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pitchResponse) }}
            />


            <div sx={{ padding: '10px', width: '100%', marginTop: '20px', marginBottom: '60px' }}>
              <IconButton onClick={() => { likeFeedback() }}>
                {!feedback_liked ? (
                  <ThumbUpAltOutlined sx={{ color: "rgb(112 48 160)" }} />
                ) : (
                  <ThumbUpAlt sx={{ color: "rgb(112 48 160)" }} />
                )}
              </IconButton>
              <IconButton onClick={() => { dislikeFeedback() }}>
                {!feedback_disliked ? (
                  <ThumbDownAltOutlined sx={{ color: "rgb(112 48 160)" }} />
                ) : (
                  <ThumbDownAlt sx={{ color: "rgb(112 48 160)" }} />
                )}
              </IconButton>
              <Button variant="contained" color="primary" sx={{ width: '20%', float: 'right', }} onClick={handleClose}>Close</Button>
            </div>

          </div>
        </div>
      </Modal>


        {/* If fewer than two EBI-enabled products, show an info card */}
        {selectedProductCodes.length < 2 ? (
          <Card
            sx={{
              mt: 2,
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
              borderRadius: 2,
            }}
          >
            <CardContent>
              <Typography variant="body1">
                Comparison or product-mix benefits need EBI data for at least two products.
                You can still proceed to the next step if you wish.
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <>
            {loading ? (
              <CircularProgress sx={{ mt: 4 }} />
            ) : (
              <>
                {comparisonOutput && (
                  <Card
                    sx={{
                      mt: 2,
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                      backdropFilter: 'blur(10px)',
                      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography variant="h6">{cardSubHeading}</Typography>
                      <Typography
                        component="div"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(comparisonOutput),
                        }}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ mt: 4 }}
                        onClick={generateComparison}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={24} /> : 'Regenerate'}
                      </Button>
                    </CardContent>
                  </Card>
                )}
                {combinedEbiData && Object.keys(combinedEbiData).length > 0 && (
                  <Card
                    sx={{
                      mt: 4,
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                      backdropFilter: 'blur(10px)',
                      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 2 }}>
                        Combined EBI Data
                      </Typography>
                      <div style={{ height: 400, width: '100%' }}>
                        <DataGrid
                          columns={columns}
                          rows={rows}
                          pageSize={5}
                          rowsPerPageOptions={[5]}
                          disableSelectionOnClick
                        />
                      </div>
                    </CardContent>
                  </Card>
                )}
              </>
            )}
          </>
        )}
        {/* Always-available Next button */}
        <Box sx={{ textAlign: 'right', mt: 4, mb: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={loading}
          >
            {nextStepLabel}
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
}
export default ProductComparison;
